<template>
  <div>
    <DialogBase
      v-model="inputedValue.dialog"
      :title="$t('common.input_company-info-setting')"
      width="510"
      isPadding0="true"
    >
      <v-card class="content">
        <v-row no-gutters align="center">
          <v-col>
            <InputFormNew
              v-model="inputData"
              :detail="detail"
              :rowHeight="inputFormStyle.inputItemHeight"
              :titleCols="inputFormStyle.titleCols"
              :contentsCols="inputFormStyle.contentsCols"
            >
              <template #organizationLogoUrl="{ item }">
                <div class="logo">
                  <input
                    style="display: none"
                    @change="formatSelectedFile()"
                    ref="input"
                    type="file"
                    name="file"
                  />
                  <div style="position: relative">
                    <div v-if="item.organizationLogoUrl">
                      <v-img
                        :src="item.organizationLogoUrl"
                        :width="120"
                        :height="60"
                      />
                    </div>
                    <div v-else class="logo-noimage">{{ 'LOGO' }}</div>
                  </div>
                  <v-btn
                    class="logo-upload"
                    depressed
                    outlined
                    color="#6a6a6a"
                    @click="triggerFormatSelectedFile"
                    >{{ $t('user.user_image-upload') }}</v-btn
                  >
                </div>
              </template>
              <template #postalCode="{ item }">
                <!-- 郵便番号 -->
                <PostalCodeArea
                  v-model="item.postalCode"
                  :countryId="item.country.value"
                  :height="inputFormStyle.inputItemHeight"
                  @click="onClickPostalCodeInvoiceInfo"
                />
              </template>
            </InputFormNew>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <NormalButton
              :text="$t('common.input_save')"
              height="50px"
              textSize="16px"
              @click="submit"
            />
          </v-col>
        </v-row>

        <v-card-actions class="pa-0 pt-2">
          <v-spacer />
          <v-btn
            color="error"
            text
            small
            :disabled="!isWithdrawable"
            @click="withdraw"
          >
            {{ $t('common.input_organization-withdraw') }}
          </v-btn>
        </v-card-actions>
        </v-card>
    </DialogBase>
    <DialogAlertSuccess
      v-model="completeDialog"
      :text="$t('user.user_company-info-setting-have-been-saved')"
      width="470px"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  masterUtil,
  countryCallingCodeUtil,
  countryUtil,
  currencyUtil,
  commonUtil
} from '@/util'
import DialogBase from './DialogBase'
import NormalButton from '@/components/items/Buttons/NormalButton'
import PostalCodeArea from '@/components/items/Designs/PostalCodeArea'
import InputFormNew from '@/components/items/Designs/InputFormNew'
import DialogAlertSuccess from '@/components/layouts/Dialogs/DialogAlert/DialogAlertSuccess'
import { fileUploadFileType } from '@/config'
import { router } from '@/main.js'

export default {
  components: {
    DialogBase,
    InputFormNew,
    NormalButton,
    PostalCodeArea,
    DialogAlertSuccess
  },
  props: {
    value: {
      dialog: false
    }
  },
  data: () => ({
    userList: {
      users: [],
      invitations: []
    },
    isFetching: false,
    inputFormStyle: {
      titleCols: 3,
      contentsCols: 9
    },
    inputData: {},
    detail: [
      {
        name: 'name',
        text: 'user.user_company-name',
        required: true
      },
      {
        name: 'organizationLogoUrl',
        text: 'user.user_company-logo'
      },
      {
        name: 'phone',
        text: 'common.input_phone-number',
        component: 'PhoneNumberInput'
      },
      {
        name: 'fax',
        text: 'common.input_fax-number',
        component: 'PhoneNumberInput'
      },
      {
        name: 'country',
        text: 'common.input_country',
        cols: Math.ceil((12 - 3) / 2),
        component: 'SelectCountry'
      },
      {
        name: 'postalCode',
        text: 'common.input_postal-code',
        cols: Math.ceil((12 - 3) / 2)
      },
      {
        name: 'region',
        text: 'common.input_region',
        cols: Math.ceil((12 - 3) / 2),
        component: 'SelectRegion'
      },
      {
        name: 'address1',
        text: 'common.input_address_1'
      },
      {
        name: 'address2',
        text: 'common.input_address_2'
      },
      {
        name: 'registrationNumber',
        text: 'common.common_registration-number'
      }
    ],
    completeDialog: false,
    uploadFile: null
  }),

  methods: {
    ...mapActions('User', [
      'getUserInfoFromApi',
      'registerOrganization',
      'getUserListFromApi',
      'organizationWithdraw'
    ]),
    ...mapActions('Common', [
      'getCurrencyListFromApi',
      'getCountryListFromApi',
      'getCountryCallingCodeListFromApi'
    ]),
    ...mapActions('FileStore', ['fileUpload']),
    ...mapGetters('Common', [
      'getCountryCallingCodeJpFromState',
      'getCurrencyJpFromState'
    ]),
    ...mapGetters('User', ['getUserInfoFromState', 'getUserListFromState']),
    async init() {
      this.inputData = this.initialInputData
      this.startFetch()
      await Promise.all([
        this.getUserInfoFromApi(),
        this.getCurrencyListFromApi(),
        this.getCountryListFromApi(),
        this.getCountryCallingCodeListFromApi(),
        this.getUserListFromApi()
      ]).then((messages) => {
        const userData = messages[0].data
        const loginUser = this.getUserInfoFromState()
        const UserList = this.getUserListFromState().map((ele) => {
          ele.isLoginUser = loginUser.id === ele.id
          ele.authorityTmp = this.getAuthority(ele.authorityId)
          return ele
        })
        this.userList.users = UserList.filter(
          (ele) => !ele.invitedAt && !!ele.email
        )
        this.userList.invitations = UserList.filter(
          (ele) => ele.invitedAt && !!ele.email
        )
        this.createData({ loginUserCompany: userData.organization })
        this.stopFetch()
      })
    },
    getAuthority(id) {
      return masterUtil.getAuthorityList().find((ele) => id === ele.value)
    },
    startFetch() {
      this.isFetching = true
    },
    stopFetch() {
      this.isFetching = false
    },
    createData({ loginUserCompany = null }) {
      this.inputData = loginUserCompany
        ? {
            name: loginUserCompany.name,
            country: countryUtil.getCountryIdInfo(loginUserCompany.countryId),
            organizationLogoUrl: loginUserCompany.organizationLogoUrl,
            phone: {
              countryCode: !loginUserCompany.phoneNumber
                ? this.getCountryCallingCodeJpFromState()
                : countryCallingCodeUtil.getPhoneNumberCountryIdInfo(
                    loginUserCompany.phoneNumberCountryId
                  ),
              phoneNumber: loginUserCompany.phoneNumber
            },
            fax: {
              countryCode: !loginUserCompany.phoneNumber
                ? this.getCountryCallingCodeJpFromState()
                : countryCallingCodeUtil.getPhoneNumberCountryIdInfo(
                    loginUserCompany.faxNumberCountryId
                  ),
              phoneNumber: loginUserCompany.faxNumber
            },
            postalCode: loginUserCompany.postalCode,
            region: countryUtil.getRegionInfo(
              loginUserCompany.countryId,
              loginUserCompany.regionId
            ),
            address1: loginUserCompany.address1,
            address2: loginUserCompany.address2,
            registrationNumber: loginUserCompany.registrationNumber
          }
        : this.initialInputData
    },
    onClickPostalCodeInvoiceInfo(...args) {
      const [address] = args
      this.inputData.region = countryUtil.getRegionInfoByName(
        this.inputData.country.value,
        address.region
      )
      this.inputData.address1 = address.locality
      this.inputData.address2 = address.street
    },
    async withdraw() {
      if (this.isFetching) {
        return
      }
      if (confirm(this.$t('common.input_organization-withdraw-question'))) {
        this.startFetch()
        const result = await this.organizationWithdraw({
          userId: this.getUserInfoFromState().id
        })
        if (result) {
          alert(this.$t('common.input_organization-withdraw-success'))
          this.stopFetch()
          router.push({ name: 'Login' }).catch(() => {})
        }
      }
    },
    async submit() {
      if (this.isFetching) {
        return
      }
      if (confirm(this.$t('common.common_save-question'))) {
        this.startFetch()
        if (this.uploadFile) {
          const formData = new FormData()
          formData.append('uploadFile', this.uploadFile)
          const uploadData = await this.fileUpload(formData)
          this.inputData.organizationLogoUrl = uploadData.data
        }
        const { country, phone, fax, region } = this.inputData
        const phoneCountry = phone.countryCode
        const faxCountry = fax.countryCode
        const params = {
          organizationName: this.inputData.name,
          countryId: country.value,
          postalCode: this.inputData.postalCode,
          regionId: commonUtil.formatRegion(region, true),
          region: commonUtil.formatRegion(region, false),
          address1: this.inputData.address1,
          address2: this.inputData.address2,
          phoneNumberCountryId: phoneCountry.value,
          phoneNumber: phone.phoneNumber,
          faxNumberCountryId: faxCountry.value,
          faxNumber: fax.phoneNumber,
          organizationLogoUrl: this.inputData.organizationLogoUrl,
          registrationNumber: this.inputData.registrationNumber
        }
        this.completeDialog = await this.registerOrganization(params)
        this.stopFetch()
      }
    },
    triggerFormatSelectedFile() {
      if (this.isFetching) {
        return
      }
      this.$refs.input.click()
    },
    formatSelectedFile() {
      this.uploadFile = this.$refs.input.files[0]
      if (!this.uploadFile) {
        return
      }
      const approvedType = fileUploadFileType.APPROVE_UPLOAD_IMAGE_FILE_TYPE
      const hasApproved = approvedType.includes(this.uploadFile.type)
      if (!hasApproved) {
        alert(this.$t('common.common_not-approved-file-type'))
        return
      }
      const uploadFileUrl = URL.createObjectURL(this.uploadFile)
      this.inputData.organizationLogoUrl = uploadFileUrl
    }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    },
    initialInputData() {
      return {
        name: '',
        currency: {},
        country: {},
        organizationLogoUrl: '',
        phone: {
          phoneNumberCountry: '',
          phoneNumber: ''
        },
        fax: {
          countryCode: {},
          phoneNumber: ''
        },
        postalCode: '',
        region: { label: '', value: null },
        address1: '',
        address2: '',
        registrationNumber: ''
      }
    },
    /**
     * 組織から退会可能かどうかを判定します。
     * @returns {boolean} 退会可能な場合はtrue
     */
    isWithdrawable() {
      return (
        this.userList.users.length === 1 &&
        this.userList.invitations.length === 0
      )
    }
  },
  watch: {
    inputedValue: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal.dialog) this.init()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  padding: 20px 30px !important;
}

.logo {
  position: relative;
  width: 120px;
  height: 60px;
  display: flex;

  &-noimage {
    background-color: #dddddd;
    color: #cccccc;
    width: 120px;
    height: 60px;
    font-size: 24px;
    line-height: 66px;
    text-align: center;
  }

  &-upload {
    width: 131px;
    margin-left: 10px;
    border-color: #c8cfd7;
    font-weight: bold;
  }
}
</style>
